import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import logo from '../assets/logo.png';

function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinkClass = ({ isActive }) => (isActive ? 'active' : '');
  return (
    <header className={`site-header ${scrolled ? 'scrolled' : ''}`}>
      <Link to="/" className="header-logo">
        <img src={logo} alt="AGRO-INVEST" className="header-logo-img" />
      </Link>
      <nav className="header-nav">
        <ul className={`nav-links ${menuOpen ? 'active' : ''}`}>
          <li><NavLink to="/" className={navLinkClass} end onClick={() => setMenuOpen(false)}>Home</NavLink></li>
          <li><NavLink to="/about" className={navLinkClass} onClick={() => setMenuOpen(false)}>About Us</NavLink></li>
          <li><NavLink to="/mission-vision" className={navLinkClass} onClick={() => setMenuOpen(false)}>Mission & Vision</NavLink></li>
          <li><NavLink to="/how-it-works" className={navLinkClass} onClick={() => setMenuOpen(false)}>How It Works</NavLink></li>
          <li><NavLink to="/marketplace" className={navLinkClass} onClick={() => setMenuOpen(false)}>Marketplace</NavLink></li>
          <li><NavLink to="/impact-metrics" className={navLinkClass} onClick={() => setMenuOpen(false)}>Impact</NavLink></li>
          <li><NavLink to="/partners" className={navLinkClass} onClick={() => setMenuOpen(false)}>Partners</NavLink></li>
          <li><NavLink to="/legal" className={navLinkClass} onClick={() => setMenuOpen(false)}>Legal</NavLink></li>
          <li><NavLink to="/contact" className={navLinkClass} onClick={() => setMenuOpen(false)}>Contact</NavLink></li>
          <li className="nav-login-mobile"><Link to="/login" className="btn btn-outline" onClick={() => setMenuOpen(false)}>Login</Link></li>
        </ul>
        <button
          className="menu-toggle"
          aria-label="Toggle menu"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          ☰
        </button>
      </nav>
      <div className="header-actions">
        <Link to="/login" className="btn btn-outline">Login</Link>
      </div>
    </header>
  );
}

export default Header;
